import * as Sentry from '@sentry/react'
import { type ReactNode, useEffect } from 'react'
import { useRouteError } from 'react-router'

import { Button } from '@/components/ui/button'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'

/** A whole-page failure on Cai's own design-system card, with Try again and any further way out. */
export function CaiAgentError({
  title = 'Cai is unavailable.',
  message,
  onRetry,
  children,
}: {
  title?: string
  message: string
  onRetry: () => void
  children?: ReactNode
}) {
  return (
    <main className="mx-auto flex min-h-screen max-w-xl items-center p-6">
      <Card className="w-full">
        <CardHeader>
          <CardTitle>{title}</CardTitle>
        </CardHeader>
        <CardContent className="space-y-6">
          <p role="alert" className="text-muted-foreground">
            {message}
          </p>
          <div className="flex flex-wrap items-center gap-3">
            <Button size="lg" onClick={onRetry}>
              Try again
            </Button>
            {children}
          </div>
        </CardContent>
      </Card>
    </main>
  )
}

/** Reports a failed Cai route without sending staff into another product. */
export function CaiAgentRouteError() {
  const error = useRouteError()
  useEffect(() => {
    Sentry.captureException(error)
  }, [error])
  return (
    <CaiAgentError
      message="We could not open this page. Try again to reload it."
      onRetry={() => window.location.reload()}
    />
  )
}
